import { render, staticRenderFns } from "./ImageFromServer.vue?vue&type=template&id=1588e6d6&scoped=true&"
import script from "./ImageFromServer.vue?vue&type=script&lang=js&"
export * from "./ImageFromServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588e6d6",
  null
  
)

export default component.exports